// extracted by mini-css-extract-plugin
export default {"wrap":"SF-z","fullWidth":"TF-z","hideOnDesktop":"UF-z","content":"VF-z","hasOpenedNav":"WF-z","crumbsList":"XF-z","dropdownsWrap":"YF-z"};